document.addEventListener('DOMContentLoaded', function () {
	const filtersButton = document.querySelector('.mobile-filters');
	const filtersContent = document.querySelector('.mobile-filters-content');
	const closeButton = document.querySelector('.mobile-filters--close');

	if (filtersButton && filtersContent && closeButton) {
	  // Esconde o conteúdo dos filtros ao carregar a página
	  filtersContent.style.display = 'none';

	  // Evento para abrir os filtros
	  filtersButton.addEventListener('click', function () {
		filtersButton.style.display = 'none'; // Esconde o botão de filtros
		filtersContent.style.display = 'block'; // Mostra o conteúdo dos filtros
	  });

	  // Evento para fechar os filtros
	  closeButton.addEventListener('click', function () {
		filtersContent.style.display = 'none'; // Esconde o conteúdo dos filtros
		filtersButton.style.display = 'flex'; // Mostra novamente o botão de filtros
	  });
	}
  });
